import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type HomeRelativePath = '/dashboard' | '/partners';

export const featureDefinition = {
  root: '/home',
  iconName: 'home',
  items: {
    '/dashboard': {
      label: 'My Dashboard',
      trackingId: 'app-nav-item-dashboard',
      description: 'A personalized home page and dashboard that surfaces key insights, metrics, and quick actions.',
    },
    '/partners': {
      label: 'Our Partners',
      trackingId: 'app-nav-item-our-partners',
      description:
        'Showcases integrated partners, third-party services, and potential add-ons available for your account.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/home', 'home', HomeRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/partners': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<HomeRelativePath>;
